<template>
  <div>
    <div class="row align-items-center">
      <div class="col-md-8">
        <h5 class="font-weight-bold mb-0">{{ data.first_name }} {{ data.last_name }}</h5>
        <p>
          <span class="pr-2">Student ID:</span> <span class="font-weight-bold px-2">{{ data.student_code }}</span>|
          <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{ data.enrollment[0].school_class ? data.enrollment[0].school_class.name : 'Not Assigned' }}</span>|
          <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{ data.enrollment[0].section ? data.enrollment[0].section.name : 'Not Assigned' }}</span>|
          <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{ data.enrollment[0].roll_no }}</span>
        </p>
      </div>
      <div class="col-md-4 text-md-right">
        <button
          v-if="rolesetting.insertable"
          type="button"
          class="btn btn-sm btn-primary btn-with-addon mr-2"
          @click="handleAddFee(data.enrollment[0])"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-plus-circle" />
          </span>
          Add Fee
        </button>
        <button
          v-if="rolesetting.editable"
          type="button"
          class="btn btn-sm btn-primary btn-with-addon"
          @click="handlePayAll(data.enrollment[0])"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-credit-card" />
          </span>
          Pay All Fees
        </button>
      </div>
    </div>

    <hr class="m-0">

    <div class="row">
      <!-- One time Fees -->
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">One Time Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Disc.</th>
                  <th>Disc. %</th>
<!--                  <th>Due</th>-->
                  <th>Total</th>
                  <!--<th>Start Date</th>-->
                  <th>Due Date</th>
                  <th>Status</th>
                  <th>Paid Amt.</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="studentFee in getOneTimeFees(data.enrollment[0].student_fees)"
                  :key="studentFee.id"
                >
                  <th>{{ studentFee.fee_setting.class_fee ? studentFee.fee_setting.class_fee.fee.name : 'Deleted' }}</th>
                  <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                  <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
<!--                  <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>-->
                  <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
<!--                  <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td>-->
                  <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                  <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.total_paid_amount ? studentFee.total_paid_amount : 0.0 }}</td>
                  <td class="text-right">
                    <a
                      v-if="studentFee.payment_status == 1 && rolesetting.viewable"
                      href="javascript:;"
                      :class="['p-1 mr-2 text-primary neo-icon-btn']"
                      @click="handleViewReceipt(studentFee, data)"
                    >
                      <i class="fe fe-eye" />
                    </a>
                    <a-tooltip
                      placement="top"
                      title="Edit paid fee"
                    >
                      <a v-if="(studentFee.payment_status == 1 && !studentFee.student_fees_payment[0].student_fee_payment.is_gateway) && rolesetting.editable"
                         href="javascript:"
                         :class="['p-1 mr-2 text-primary neo-icon-btn', `${!studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                         @click="showEditPaidFeeModal(studentFee,data)"
                         :disabled="studentFee.payment_status === 0"
                      >
                        <i class="btn-addon-icon fe fe-edit" />
                      </a>
                    </a-tooltip>
                    <a v-if="(studentFee.payment_status == 0 || studentFee.student_fees_payment[0].student_fee_payment.is_gateway === 1) && rolesetting.editable"
                      href="javascript:;"
                      :class="['p-1 mr-2 text-success neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handlePay(studentFee,data)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-credit-card" />
                    </a>
                    <a-tooltip
                      placement="top"
                      title="Delete fee"
                    >
                      <a v-if="studentFee.payment_status == 0 && rolesetting.deletable"
                         href="javascript:"
                         :class="['p-1 mr-2 text-danger neo-icon-btn']"
                         @click="handleDeleteStudentFee(studentFee,data)"
                         :disabled="studentFee.payment_status === 1"
                      >
                        <i class="btn-addon-icon fe fe-trash" />
                      </a>
                    </a-tooltip>
                    <a
                      v-if="rolesetting.editable"
                      href="javascript:;"
                      :class="['p-1 text-dark neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handleEdit(studentFee)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-settings" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
      <!-- Custom Fees -->
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">Recurring Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Disc.</th>
                  <th>Disc. %</th>
<!--                  <th>Due</th>-->
                  <th>Type</th>
                  <th>Total</th>
                  <!--<th>Start Date</th>-->
                  <th>Due Date</th>
                  <th>Status</th>
                  <th>Paid Amt.</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="studentFee in getRecurringFees(data.enrollment[0].student_fees)"
                  :key="studentFee.id"
                >
                  <th>{{ studentFee.fee_setting.class_fee ? studentFee.fee_setting.class_fee.fee.name : 'Deleted' }}</th>
                  <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                  <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
<!--                  <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>-->
                  <td class="font-weight-bold">{{ getFeeType(studentFee.fee_type) }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
<!--                  <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td>-->
                  <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                  <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.total_paid_amount ? studentFee.total_paid_amount : 0.0 }}</td>
                  <td class="text-right">
                    <a-tooltip
                      placement="top"
                      title="View receipt"
                    >
                      <a
                        v-if="studentFee.payment_status == 1 && rolesetting.viewable"
                        href="javascript:;"
                        :class="['p-1 mr-2 text-primary neo-icon-btn']"
                        @click="handleViewReceipt(studentFee, data)"
                      >
                        <i class="fe fe-eye" />
                      </a>
                    </a-tooltip>
                    <a-tooltip
                      placement="top"
                      title="Edit paid fee"
                    >
                      <a v-if="(studentFee.payment_status == 1 && !studentFee.student_fees_payment[0].student_fee_payment.is_gateway) && rolesetting.editable"
                         href="javascript:"
                         :class="['p-1 mr-2 text-primary neo-icon-btn', `${!studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                         @click="showEditPaidFeeModal(studentFee,data)"
                         :disabled="studentFee.payment_status === 0"
                      >
                        <i class="btn-addon-icon fe fe-edit" />
                      </a>
                    </a-tooltip>
                    <a-tooltip
                      placement="top"
                      title="Pay single fee"
                    >
                      <a
                        v-if="(studentFee.payment_status == 0 || studentFee.student_fees_payment[0].student_fee_payment.is_gateway === 1) && rolesetting.editable"
                        href="javascript:;"
                        :class="['p-1 mr-2 text-success neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                        @click="handlePay(studentFee,data)"
                        :disabled="studentFee.payment_status === 1"
                      >
                        <i class="fe fe-credit-card" />
                      </a>
                    </a-tooltip>
                    <a-tooltip
                      placement="top"
                      title="Delete fee"
                    >
                      <a v-if="studentFee.payment_status == 0 && rolesetting.deletable"
                         href="javascript:"
                         :class="['p-1 mr-2 text-danger neo-icon-btn']"
                         @click="handleDeleteStudentFee(studentFee,data)"
                         :disabled="studentFee.payment_status === 1"
                      >
                        <i class="btn-addon-icon fe fe-trash" />
                      </a>
                    </a-tooltip>
                    <a
                      v-if="rolesetting.editable"
                      href="javascript:;"
                      :class="['p-1 text-dark neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handleEdit(studentFee)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-settings" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">Custom Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
              <tr>
                <th>Fees</th>
                <th>Amount</th>
                <th>Fine</th>
                <th>Disc.</th>
                <th>Disc. %</th>
                <!--                  <th>Due</th>-->
                <th>Type</th>
                <th>Total</th>
                <!--<th>Start Date</th>-->
                <th>Due Date</th>
                <th>Status</th>
                <th>Paid Amt.</th>
                <th class="text-right">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="studentFee in getIndividualFees(data.enrollment[0].student_fees)"
                :key="studentFee.id"
              >
                <th>{{ studentFee.fee_setting.fee ? studentFee.fee_setting.fee.name : 'Deleted' }}</th>
                <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
                <!--                  <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>-->
                <td class="font-weight-bold">{{ getFeeType(studentFee.fee_type) }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
                <!--                  <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td>-->
                <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.total_paid_amount ? studentFee.total_paid_amount : 0.0 }}</td>
                <td class="text-right">
                  <a-tooltip
                    placement="top"
                    title="View receipt"
                  >
                    <a
                      v-if="studentFee.payment_status == 1 && rolesetting.viewable"
                      href="javascript:;"
                      :class="['p-1 mr-2 text-primary neo-icon-btn']"
                      @click="handleViewReceipt(studentFee, data)"
                    >
                      <i class="fe fe-eye" />
                    </a>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="Edit paid fee"
                  >
                    <a v-if="(studentFee.payment_status == 1 && !studentFee.student_fees_payment[0].student_fee_payment.is_gateway) && rolesetting.editable"
                       href="javascript:"
                       :class="['p-1 mr-2 text-primary neo-icon-btn', `${!studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                       @click="showEditPaidFeeModal(studentFee,data)"
                       :disabled="studentFee.payment_status === 0"
                    >
                      <i class="btn-addon-icon fe fe-edit" />
                    </a>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="Pay single fee"
                  >
                    <a
                      v-if="(studentFee.payment_status == 0 || studentFee.student_fees_payment[0].student_fee_payment.is_gateway === 1) && rolesetting.editable"
                      href="javascript:;"
                      :class="['p-1 mr-2 text-success neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handlePay(studentFee,data)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-credit-card" />
                    </a>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="Delete fee"
                  >
                    <a v-if="studentFee.payment_status == 0 && rolesetting.deletable"
                       href="javascript:"
                       :class="['p-1 mr-2 text-danger neo-icon-btn']"
                       @click="handleDeleteStudentFee(studentFee,data)"
                       :disabled="studentFee.payment_status === 1"
                    >
                      <i class="btn-addon-icon fe fe-trash" />
                    </a>
                  </a-tooltip>
                  <a
                    v-if="rolesetting.editable"
                    href="javascript:;"
                    :class="['p-1 text-dark neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                    @click="handleEdit(studentFee)"
                    :disabled="studentFee.payment_status === 1"
                  >
                    <i class="fe fe-settings" />
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

import { feeTypes } from '@/services/globaldata'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'DisplayStudentFees',
  props: ['data', 'rolesetting'],
  components: {
    vueCustomScrollbar,
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  methods: {
    moment,
    getOneTimeFees(data) {
      const oneTime = data.filter(element => element.fee_type === 1)
      return oneTime
    },
    getRecurringFees(studentFees) {
      const recurring = studentFees.filter(studentFee => studentFee.fee_type !== 1 && studentFee.fee_setting.class_fee) // Select only class fees and not individual fees
      return recurring
    },
    getIndividualFees(studentFees) {
      const individualFees = studentFees.filter(studentFee => (studentFee.fee_setting.fee ? studentFee.fee_setting.fee.target_type === 3 : false)) // 3 => Individual fees
      return individualFees
    },
    getFeeType(type) {
      return find(this.feeTypes, { value: type }).name
    },
    handlePay(studentFee, data) {
      this.$eventBus.$emit('openStudentFeePayModal', [studentFee, data.enrollment[0].student_id])
    },
    showEditPaidFeeModal(studentFee, data) {
      this.$eventBus.$emit('openEditPaidFeeModal', [studentFee, data.enrollment[0].student_id])
    },
    handleEdit(studentFee) {
      this.$eventBus.$emit('openStudentFeeEditModal', studentFee)
    },
    handlePayAll(studentFees) {
      this.$eventBus.$emit('openPayAllStudentFeesModal', studentFees)
    },
    handleAddFee(studentFees) {
      this.$eventBus.$emit('openAddStudentFeesModal', studentFees)
    },
    handleDeleteStudentFee(studentFee, data) {
      this.$confirm({
        title: 'Are you sure?',
        content: `The student fee will be deleted if you click Yes`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student_fee/' + studentFee.id)
            .then(() => {
              this.$emit('updateStudentFeeTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The student fee has been deleted successfully!',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleViewReceipt(studentFee, data) {
      const student = {
        first_name: data.first_name,
        last_name: data.last_name,
        student_code: data.student_code,
        class_name: data.enrollment[0].school_class.name,
        section_name: data.enrollment[0].section ? data.enrollment[0].section.name : 'NA',
        roll_no: data.enrollment[0].roll_no ? data.enrollment[0].roll_no : 'NA',
        id: data.id,
      }
      this.$eventBus.$emit('openViewStudentFeeReceiptModal', studentFee, student)
    },
  },
}
</script>
